











































































































































































































































































































































































































































































































































































// @ts-nocheck
import TitleBar from "@/components/Elements/TitleBar.vue";

import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters, mapState, mapActions } from "vuex";

import { STORE_KEY, store } from "./_store";
import moment from "moment";

import VueApexCharts from "vue-apexcharts";

import ImportResult from "./ImportResult.vue";
import Tooltip from "@/components/Elements/Tooltip.vue";
import Combobox from "@/components/Controls/Combobox.vue";

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      "loading",
      "loaded",
      "fatalError",

      "items",
      "total",
      "graphicList",
      "filter",
      "payments",
    ]),
    ...mapGetters(STORE_KEY, ["byMonthy", "totalPayments"]),
    ...mapGetters("ubic", ["isAdmin", "isController"]),
  },
  methods: {
    ...mapActions(STORE_KEY, [
      "setReportOptions",
      "exportDataAsXLSX",
      "removeItem",
    ]),
  },
  components: {
    TitleBar,
    VueApexCharts,
    Tooltip,
    Combobox,
  },
})
export default class MarginalityReport extends Vue {
  cash_file: any = null;
  cashless_file: any = null;
  byMonthy!: any;
  filter!: any;

  modal: any = null;

  checkedRows: any[] = [];

  get titleStack() {
    return ["Отчеты", "По маржинальности"];
  }

  localFilter = {
    employees: null,
    clients: null,
    dZoneGroups: null,
    no_group: false,
    targetDates: [new Date(), new Date()],
  };
  columnsList: any[] = [
    { id: "client_name", label: "Клиент" },
    { id: "manager_name", label: "Менеджер" },
    { id: "secondary_manager_name", label: "Со-менеджер" },
    { id: "agent_name", label: "Агент" },
    { id: "city_name", label: "Город" },
    { id: "category", label: "Категория" },
    { id: "weight", label: "Объем отгрузок, кг" },
    { id: "income", label: "Выручка, руб" },
    { id: "prime_cost", label: "Себестоимость" },
    { id: "profit", label: "Маржинальная прибыль, руб" },
    { id: "profit_percent", label: "Маржинальная прибыль, %" },
    { id: "cash_payments", label: "Оплата УО" },
    { id: "cashless_payments", label: "Оплата ИП" },
    { id: "payments", label: "Сумма поступлений" },
    { id: "payments_percent", label: "МП от оплаченного" },
    { id: "delivery_cost", label: "Сумма транспортных затрат" },
    { id: "delivery_cost_by_weight", label: "Транспортные затраты на кг" },
    { id: "payments_to_calc", label: "Сумма к начислению" },
    { id: "category_income", label: "Категория объемов" },
    { id: "accural_percent", label: "Процент начисления" },
    { id: "accural_sum", label: "Сумма процента начисления, руб" },
  ];
  showColumns: any[] = [];

  get defaultSort() {
    return [
      this.$route.query.sortField || "weight",
      this.$route.query.sortDirection || "desc",
    ];
  }

  get isAccepted() {
    const idx =
      parseInt(moment(this.$route.query.targetDates[1]).format("MM")) - 1;
    return this.byMonthy && this.byMonthy[idx]
      ? this.byMonthy[idx].is_accepted
      : false;
  }

  uploadFile(file: File, type: string) {
    const formData = new FormData();

    formData.append("type", type);
    formData.append("file", file);

    // @ts-ignore
    this.$http
      .post(`/api/v1/cash_import`, formData, {})
      .then((response: any) => {
        if (response.data.result.length) {
          this.modal = this.$buefy.modal.open({
            component: ImportResult,
            props: {
              unconnected: response.data.result.map((item: any) => {
                if (type == "cash") {
                  return {
                    date: item[2],
                    payment: item[3],
                    payer: item[6],
                    inn: item[5],
                    operation: item[7],
                    reasone: item[8],
                  };
                } else {
                  return {
                    date: item[2],
                    payment: item[3],
                    payer: item[7],
                    inn: item[6],
                    operation: item[8],
                    reasone: item[5],
                  };
                }
              }),
            },
            onCancel: () => {
              this.modal.close();
            },
            hasModalCard: true,
            fullScreen: true,
            customClass: "document-form",
            parent: this,
          });
        } else {
          this.$buefy.toast.open({
            message: `Файл ${file.name} импортирован`,
            type: "is-success",
          });
        }
      });
  }

  onSort(field: string, direction: string) {
    console.log("onSort", field, direction);
    this.$router.replace({
      query: {
        ...this.$route.query,
        sortField: field,
        sortDirection: direction,
      },
    });
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  setColumns(value: any[]) {
    // @ts-ignore
    this.$storage.set({
      key: "marginality_report_columns",
      value: JSON.stringify(value),
    });
  }

  removeItem(row: any) {
    // @ts-ignore
    const datetime = this.$options.filters.date(row.datetime);
    this.$buefy.dialog.confirm({
      message: `Удалить платеж на сумму ${row.payment} руб. от ${datetime} (клиент: ${row.client_name})?`,
      confirmText: "Удалить",
      cancelText: "Отмена",
      trapFocus: true,
      onConfirm: (value: any) => {
        this.$store
          .dispatch(`${STORE_KEY}/removeItem`, row)
          .then((result) => {
            this.$buefy.snackbar.open(`Запись удалена`);
            this.handleParamsChange();
          })
          .catch(() => {
            this.$buefy.snackbar.open({
              type: "is-warning",
              message: `При сохранении возникли проблемы. Попробуйте позже.`,
            });
          });
      },
    });
  }

  removeManyItems(type: string, from: any, to: any) {
    const typeLabel = type == "cash" ? "наличные" : "безналичные";
    const formData = new FormData();

    formData.append("type", type);
    formData.append("from", moment(from).format("YYYY-MM-DD"));
    formData.append("to", moment(to).format("YYYY-MM-DD"));
    // @ts-ignore
    this.$buefy.dialog.confirm({
      message: `Удалить все ${typeLabel} платежи?`,
      confirmText: "Удалить",
      cancelText: "Отмена",
      trapFocus: true,
      onConfirm: (value: any) => {
        // @ts-ignore
        this.$http
          .post(`/api/v1/cash_delete`, formData, {})
          .then((response: any) => {
            //
          });
      },
    });
  }

  removeItems() {
    // @ts-ignore
    const sums = this.checkedRows.reduce((val: number, item: any) => {
      return val + parseFloat(item.payment);
    }, 0);
    this.$buefy.dialog.confirm({
      message: `Удалить ${this.checkedRows.length} на сумму ${sums} руб.?`,
      confirmText: "Удалить",
      cancelText: "Отмена",
      trapFocus: true,
      onConfirm: (value: any) => {
        this.$store
          .dispatch(`${STORE_KEY}/removeItems`, this.checkedRows)
          .then((result) => {
            this.$buefy.snackbar.open(`Записи удалены`);
            this.handleParamsChange();
          })
          .catch(() => {
            this.$buefy.snackbar.open({
              type: "is-warning",
              message: `При сохранении возникли проблемы. Попробуйте позже.`,
            });
          });
      },
    });
  }

  public mounted() {
    // @ts-ignore
    this.localFilter.dZoneGroups =
      this.$route.query && this.$route.query.dZoneGroups
        ? this.$route.query.dZoneGroups
        : null;
    // @ts-ignore
    this.localFilter.no_group =
      this.$route.query && this.$route.query.no_group
        ? this.$route.query.no_group == "true"
        : null;
    // @ts-ignore
    this.localFilter.employees =
      this.$route.query && this.$route.query.employees
        ? this.$route.query.employees
        : null;
    // @ts-ignore
    this.localFilter.clients =
      this.$route.query && this.$route.query.clients
        ? this.$route.query.clients
        : null;
    // @ts-ignore
    this.localFilter.targetDates =
      this.$route.query && this.$route.query.targetDates
        ? [
            moment(this.$route.query.targetDates[0]).toDate(),
            moment(this.$route.query.targetDates[1]).toDate(),
          ]
        : [new Date(), new Date()];

    this.handleParamsChange();
    // @ts-ignore
    this.$storage.get({ key: "marginality_columns" }).then((data: any) => {
      let columns = data.value ? JSON.parse(data.value) : [];
      if (!Array.isArray(columns)) {
        columns = [columns];
      }
      // новая колонка «Агент»: один раз догоняем в сохранённый набор,
      // иначе у уже сохранивших свой набор она не появится
      if (columns.length > 0 && !columns.includes("agent_name")) {
        const idx = columns.indexOf("secondary_manager_name");
        columns.splice(idx >= 0 ? idx + 1 : 0, 0, "agent_name");
      }
      this.showColumns =
        columns.length > 0
          ? columns
          : this.columnsList.map((col: any) => {
              return col.id;
            });
    });
  }

  setFilterData() {
    const query = Object.keys(this.localFilter).reduce((ac: any, key) => {
      // @ts-ignore
      ac[key] =
        key == "targetDates"
          ? [
              moment(this.localFilter[key][0]).format("YYYY-MM-DD"),
              moment(this.localFilter[key][1]).format("YYYY-MM-DD"),
            ]
          : this.localFilter[key]; // @ts-ignore
      return ac;
    }, {});

    console.log("query", query);
    this.$router.replace({
      query,
    });
  }

  // ---------------------------------------------------------------------------

  @Watch("$route.query")
  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
    this.checkedRows = [];
  }
}
